import BlokWrap from "@/components/bloks/BlokWrap";
import type { BlokMedia } from "@/storyblok";
import { type BlokProps, StoryblokComponent } from "@frend-digital/storyblok";
import { clsx } from "@frend-digital/ui";
import styles from "./Media.module.css";

function getDisplayMode(displayMode: string | undefined) {
	switch (displayMode) {
		case "space-between":
			return styles.spaceBetween;
		case "center":
			return styles.center;
		default:
			return styles.spaceBetween;
	}
}

export const MediaBlok = ({
	blok,
	className,
	preview,
}: BlokProps<BlokMedia> & {
	className?: string;
}) => {
	const isSingle = blok.media?.length === 1;

	return (
		<BlokWrap
			editable={blok}
			as="div"
			className={clsx(
				styles.root,
				className,
				isSingle && styles.single,
				getDisplayMode(blok.displayMode),
			)}
		>
			{blok.media?.map((media) => (
				<StoryblokComponent
					preview={preview}
					blok={media}
					key={media._uid}
					className={clsx(styles.media, media.small && styles.small)}
				/>
			))}
		</BlokWrap>
	);
};
